export default __webpack_public_path__ + "static/media/npm.f2556cd0.svg";